export default "/fonts/vendor/katex/dist/KaTeX_Size3-Regular.woff?7947224e8a9914fa332b16515176ce0d";